import React, { useState, useEffect } from "react";
import { useQuery } from "@apollo/react-hooks";
import query from "./query.js";
import Link from "components/link";
import { ReactComponent as Arrow } from "../../assets/fh_arrow.svg";
import styles from "./alertBar.module.scss";

const AlertBar = ({ location }) => {
  const [visible, setVisible] = useState(false)
  const { loading, error, data } = useQuery(query);
  let homepage = location === "/"

  useEffect(() => {
    const { isEnabled, homepageOnly } = data ? data.alertBar : {};
    setVisible((isEnabled && homepage && homepageOnly) || (isEnabled && !homepageOnly) ? true : false)
  }, [data, homepage])

  if (loading || error) {
    return null;
  }

  const { plainText, cta } = data ? data.alertBar : {};

  return (
    visible &&
    <div className={styles.alertBar}>
      <div className={styles.alertBarText}>{plainText}</div>
      <Link className={styles.alertBarLink} {...cta}>
        <span>{cta.text}</span>
        <Arrow />
      </Link>
    </div>
  );
}

export default AlertBar